module.exports = __webpack_public_path__ + "img/1.4e77fa1a.png";